import { render, staticRenderFns } from "./Fornecedores.vue?vue&type=template&id=458ff41c&"
import script from "./Fornecedores.vue?vue&type=script&lang=js&"
export * from "./Fornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports